/* eslint-disable */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AiMessagesState {
  heygenStateOpen: boolean;
  isGreetingsDone: boolean;
}

interface AiHeygenOpenPayload {
  heygenStateOpen: boolean,
}

interface AiGreetingsPayload {
  isGreetingsDone: boolean,
}

const initialState: AiMessagesState = {
  heygenStateOpen: undefined,
  isGreetingsDone: false,
};

export const aiMessagesSlice = createSlice({
  name: 'aiMessages',
  initialState,
  reducers: {
    setHeygenOpen: (state, action: PayloadAction<AiHeygenOpenPayload>) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    setGreetingsDone: (state, action: PayloadAction<AiGreetingsPayload>) => {
      return {
        ...state,
        ...action.payload,
      }
    }
  },
});

export const { setHeygenOpen, setGreetingsDone } = aiMessagesSlice.actions;
export default aiMessagesSlice.reducer;
